<script setup lang="ts">
import { modalService } from '@/services/utils/modal.service';
import GBaseModal from './GBaseModal.vue';

const modals = modalService.modals;
</script>

<template>
    <GBaseModal
        v-for="modal in modals"
        :key="modal.id"
        :id="modal.id"
        :title="modal.title"
        :size="modal.size"
        :showCloseButton="modal.showCloseButton"
        :showHeader="modal.showHeader"
        :component="modal.component"
        :componentProps="modal.props!"
        :componentEvents="modal.events"
    />
</template>
